<template>
    <div class="flex">
        <image-button
                @click.native="showModal = true"
                img="/images/svg/ATS3Seriesicon_limit.svg">
            limit time range
        </image-button>

        <portal to="modals" v-if="showModal">
            <modal-bottom v-if="showModal" @close="close()" class="bg-grey-lighter">
                <h3 slot="header">Limit Data</h3>

                <div slot="save">
                    <a class="cursor-pointer inline-block bg-blue text-white px-4 py-2 rounded" v-show="true"
                       @click="save()">
                        Apply
                    </a>
                </div>

                <!--
                <p class="text-grey-dark text-sm">
                                    lorem ipsum
                                </p>
                -->

                <div class="flex">
                    <div class="w-1/3">Min:</div>
                    <select v-model="min" class="border rounded p-2 border-blue-dark">
                        <option
                                v-for="time in times"
                                class="bg-white cursor-pointer text-center px-4 py-2 mr-4 mb-4 border-2 border-white hover:bg-blue-lightest shadow rounded hover:border-blue-dark"
                                v-bind:value="time">
                            {{ time }}
                        </option>
                    </select>
                </div>

                <div class="mt-4 flex">
                    <div class="w-1/3">Max:</div>
                    <select v-model="max" class="border rounded p-2 border-blue-dark">
                        <option
                                v-for="time in times"
                                class="bg-white cursor-pointer text-center px-4 py-2 mr-4 mb-4 border-2 border-white hover:bg-blue-lightest shadow rounded hover:border-blue-dark"
                                v-bind:value="time">
                            {{ time }}
                        </option>
                    </select>
                </div>

                <!-- @click.stop="update('index', selected, time); time = null"-->
            </modal-bottom>
        </portal>

    </div>
</template>

<script>

    import ImageButton from "../ImageButton";
    import ModalBottom from "../ModalBottom";
    import LimitDataModifer from "../../modifiers/LimitDataModifier";

    export default {
        name: "ComputeLimitData",

        components: {ModalBottom, ImageButton},

        data: () => ({
            showModal: false,
            min: null,
            max: null,
        }),

        computed: {
            times() {
                return this.$store.getters.times;
            },
            selected() {
                return this.$store.state.rawData.data[this.$store.state.periodicity].data.map(function (item, index) {
                    return index;
                });
            },
        },

        watch: {
            showModal() {
                this.min = this.times[this.times.length - 1];
                this.max = this.times[0];
            },
            min() {
                this.modify()
            },
            max() {
                this.modify()
            }
        },

        methods: {
            close() {
                this.$store.dispatch('abort');
                this.showModal = false;
            },
            modify() {
                if (!this.showModal) {
                    return;
                }
                this.$store.dispatch('setModifier', {
                    modifier: new LimitDataModifer({
                        min: this.min,
                        max: this.max,
                    }),
                    ids: this.selected
                });
            },
            save() {
                this.$store.dispatch('save');
                this.showModal = false;
            }
        }
    }
</script>

<style scoped>

</style>
